import request from "@/router/axios";

export const getList = (data) => {
  return request({
    url: "/api/produce/safety-check-plan/select/page",
    method: "post",
    data,
  });
};
// 获取检查计划详情
export const getCheckPlanDetail = (id) => {
  return request({
    url: "/api/produce/safety-check-plan/select/id",
    method: "get",
    params: { id },
  });
};

// 新增检查计划
export const addCheckPlan = (data) => {
  return request({
    url: "/api/produce/safety-check-plan/insert",
    method: "post",
    data,
  });
};

// 更新检查计划
export const updateCheckPlan = (data) => {
  return request({
    url: "/api/produce/safety-check-plan/update",
    method: "post",
    data,
  });
};

// 删除检查计划
export const deleteCheckPlan = (id) => {
  return request({
    url: "/api/produce/safety-check-plan/delete/id",
    method: "get",
    params: { id },
  });
};

// 批量分配检查计划
export const batchAssignCheckPlan = (data) => {
  return request({
    url: "/api/produce/check-plan/batch/assign",
    method: "post",
    data,
  });
};

// 批量关闭检查计划
export const batchCloseCheckPlan = (data) => {
  return request({
    url: "/api/produce/check-plan/batch/close",
    method: "post",
    data,
  });
};

// 启动检查计划
export const startCheckPlan = (id) => {
  return request({
    url: "/api/produce/check-plan/start",
    method: "post",
    params: { id },
  });
};

// 暂停检查计划
export const pauseCheckPlan = (id) => {
  return request({
    url: "/api/produce/check-plan/pause",
    method: "post",
    params: { id },
  });
};

// 关闭检查计划
export const closeCheckPlan = (id) => {
  return request({
    url: "/api/produce/check-plan/close",
    method: "post",
    params: { id },
  });
};

// 导出检查计划
export const exportExcel = (data) => {
  return request({
    url: "/api/produce/safety-check-plan/export/excel",
    method: "post",
    data,
    responseType: "blob",
  });
};

// 获取用户列表
export const getUserList = (data) => {
  return request({
    url: "/api/produce/blade-user/select/userList",
    method: "get",
    params: data,
  });
};

// 获取部门树形数据
export const getDeptTree = () => {
  return request({
    url: "/api/produce/blade-dept/select/deptSelect",
    method: "get",
  });
};

// 根据检查类型获取关联检查表
export const getCheckListByType = (checkType) => {
  return request({
    url: "/api/produce/safety-check-list/select/queryCheckListByType",
    method: "get",
    params: { checkType },
  });
};

// 根据检查表ID获取预览检查项内容
export const getCheckListPreview = (checkListId) => {
  return request({
    url: "/api/produce/safety-check-list-ext/select/queryCheckListExt",
    method: "get",
    params: { checkListId },
  });
};

// 获取统计数据
export const getCheckPlanStats = () => {
  return request({
    url: "/api/produce/safety-check-plan/statistics/plan-status",
    method: "get",
  });
};

// 批量更新状态
export const updateStatusBatch = (data) => {
  return request({
    url: "/api/produce/safety-check-plan/update/planStatus/batch",
    method: "post",
    params: {
      ids: data.ids,
      planStatus: data.status,
    },
  });
};

// 获取检查类型下拉数据
export const getCheckTypeOptions = (safeyType = 1) => {
  return request({
    url: "/api/produce/safey-type/select/querySafeyType",
    method: "get",
    params: { safeyType },
  });
};

// 获取检查区域下拉数据
export const getAreaOptions = (safeyType = 2) => {
  return request({
    url: "/api/produce/safey-type/select/querySafeyType",
    method: "get",
    params: { safeyType },
  });
};

// 开始检查
export const startCheckPlanUp = (id) => {
  return request({
    url: `/api/produce/safety-check-plan/startCheckPlan/id`,
    method: "get",
    params: { id },
  });
};
